





























import { Component, Vue } from "vue-property-decorator";
import { Carousel } from "ant-design-vue";

@Component({
  name: "Docs",
  components: {
    ACarousel: Carousel
  }
})
export default class Docs extends Vue {
  private total = 0;
  private dataSource: any[] = [];
  // 一页显示几个项目
  private carouselStep = 8;

  private created() {
    this.getList();
  }

  private async getList() {
    const res = await this.$api.SystemFileAllList({
      status: "0"
    });
    if (res && res.code === 200) {
      this.total = res.total;
      this.dataSource = res.rows;
    }
    return res;
  }

  /**
   * fileType
   * "1": 弹出框，显示在线预览和下载
   * "2": 直接下载
   */
  private goto(obj: any) {
    if (obj.fileType === "1") {
      this.$modal.confirm({
        content: "您的选择是？",
        cancelText: "下载",
        okText: "预览",
        onCancel: () => {
          if (obj.fileUrl) {
            this.$tools.cOpen({ url: obj.fileUrl });
          } else {
            this.$modal.warning({ content: "资料地址异常！" });
          }
        },
        onOk: () => {
          if (!obj.fileTitle) {
            this.$modal.warning({ content: "资料标题异常！" });
            return;
          }

          if (!obj.fileAddr) {
            this.$modal.warning({ content: "资料地址异常！" });
            return;
          }

          const url = this.$tools.filePreview(obj.fileTitle, obj.fileAddr);
          this.$tools.cOpen({ url });
        }
      });
    } else if (obj.fileType === "2" && obj.fileAddr) {
      this.$tools.cOpen({ url: obj.fileAddr });
    } else {
      this.$modal.warning({ content: "资料预览异常！" });
    }
  }

  private get list() {
    const step = this.carouselStep;
    const _return: any[] = Array.from({ length: Math.ceil(this.dataSource.length / step) }, () => []);
    for (let i = 0; i < _return.length; i++) {
      for (let j = i * step; j < i * step + step; j++) {
        if (this.dataSource[j]) {
          _return[i].push(this.dataSource[j]);
        } else {
          break;
        }
      }
    }
    return _return;
  }
}
